// src/components/gestionEvento/forms/PrevisualizacionTema.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import EventPagePreview from './EventPagePreview'; // Importación por defecto

const PrevisualizacionTema = ({
  colorPrimario,
  colorSecundario,
  nombreEvento,
  lugar,
  fechaInicioCompetencia,
  fechaFinCompetencia,
  logoSrc,
  imagenPortadaSrc,
  redesSociales,
  contactos,
}) => {
  return (
    <Box
      sx={{
        mt: 4,
        p: 2,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
        width: '100%',
        maxWidth: 600,
      }}
    >
      {/* Título de la Previsualización */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Vista Previa del Tema
        </Typography>
      </Box>

      {/* Renderizar la vista previa del EventPage */}
      <EventPagePreview
        colorPrimario={colorPrimario}
        colorSecundario={colorSecundario}
        nombreEvento={nombreEvento}
        lugar={lugar}
        fechaInicio={fechaInicioCompetencia}
        fechaFin={fechaFinCompetencia}
        logoSrc={logoSrc}
        portadaSrc={imagenPortadaSrc}
        redesSociales={redesSociales}
        contactos={contactos}
      />
    </Box>
  );
};

export default PrevisualizacionTema;
